import ClientModule from '@gqlapp/module-client-react';
import menus from './menu'
import mobile from './mobile'

export default new ClientModule(menus, mobile)
